import { render, staticRenderFns } from "./SmsModelForm.vue?vue&type=template&id=5bb563ae&scoped=true"
import script from "./SmsModelForm.vue?vue&type=script&lang=js"
export * from "./SmsModelForm.vue?vue&type=script&lang=js"
import style0 from "./SmsModelForm.vue?vue&type=style&index=0&id=5bb563ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb563ae",
  null
  
)

export default component.exports